<template>
  <div class="reliable">
    <div class="reliable__innerwrap">
      <h1 class="reliable__title" v-html="benefit.title"></h1>
      <div class="reliable__content">
        <ul>
          <li v-for="(item, index) in benefit.list" :key="index" v-html="item"></li>
        </ul>
      </div>
      <div class="reliable__images">
        <div
          class="reliable__image"
          v-for="(image, index) in benefit.images"
          :key="index"
          :style="{ backgroundImage: `url('static/${image.src}')` }"
          v-on:click.prevent="openImage(image)"
        ></div>
        <div class="reliable__icon-wrapper"><img class="reliable__icon" :src="icon" /></div>
      </div>
    </div>
    <transition name="zoom">
      <div class="reliable__image-viewer" v-if="viewerImage">
        <div class="reliable__image-viewer-innerwrap">
          <img class="reliable__image-viewer-image" :src="`static/${viewerImage.src}`" />
          <div class="reliable__image-viewer-content">
            <a class="reliable__image-viewer-close" href="#" v-on:click.prevent="closeImage"></a>
            <p>{{viewerImage.description}}</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'reliable',
  props: ['benefit'],
  data() {
    return {
      viewerImage: null,
    };
  },
  computed: {
    image2() {
      return `static/${this.benefit.image_2}`;
    },
    icon() {
      return `static/${this.benefit.icon}`;
    },
  },
  methods: {
    openImage(image) {
      this.viewerImage = image;
    },
    closeImage() {
      this.viewerImage = null;
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.reliable {
  @include section;
  padding-bottom: 70px;

  &__innerwrap {
    flex-shrink: 0;
    padding-bottom: 10px;
  }

  &__title {
    @include font-heading;
  }

  &__content {
    @include font-content;
    margin-bottom: 40px;
  }

  &__images {
    display: flex;
    flex-wrap: wrap;
    width: calc(10 / 12 * 100%);
    margin: 0 -5px -10px;
    position: relative;
  }

  &__image {
    width: calc(1/3 * 100% - 10px);
    margin: 0 5px 10px;
    position: relative;
    height: 150px;
    background-position: center;
    background-size: cover;
    cursor: pointer;

    &::after {
      content: '';
      display: block;
      width: 50px;
      height: 50px;
      position: absolute;
      top: calc(50% - 25px);
      left: calc(50% - 25px);
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../assets/reliable_plus.svg');
    }
  }

  // &__image {
  //   display: block;
  //   width: 100%;
  //   height: 150px;
  // }

  &__icon {
    display: block;
  }

  &__icon-wrapper {
    display: block;
    position: absolute;
    top: -92px;
    right: -94px;
    // bottom: calc(100% - 40px);
    // left: 75%;

    &::after {
      content: '';
      display: block;
      width: 300px;
      height: 183px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../assets/reliable_checkbox.svg');
      position: absolute;
      bottom: 80px;
      left: -120px;
    }
  }

  .zoom-enter-active, .zoom-leave-active {
    transition: opacity .3s, transform .3s;
  }

  .zoom-enter, .zoom-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .zoom-enter-active &__image-viewer-innerwrap,
  .zoom-leave-active &__image-viewer-innerwrap {
    transition: transform .3s;
    transform-origin: 50% 50%;
  }

  .zoom-enter &__image-viewer-innerwrap,
  .zoom-leave-to &__image-viewer-innerwrap {
    transform: scale(.5);
  }

  &__image-viewer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba($c_black, .95);
  }

  &__image-viewer-innerwrap {
    display: block;
    margin: 40px;
    max-width: 730px;
    background: $c_white;
  }

  &__image-viewer-image {
    display: block;
    width: 100%;
  }

  &__image-viewer-content {
    position: relative;
    @include font-content;
    padding: 32px 40px;
    font-weight: $t_medium;
  }

  &__image-viewer-close {
    display: block;
    width: 50px;
    height: 50px;
    position: absolute;
    top: -25px;
    right: 40px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('../../assets/reliable_plus.svg');
    transform: rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Reliable.vue